export default __webpack_public_path__ + "static/cover-big-richinstead-eb3ccda7ce04a7e723228cd6008a79bc.png";